import { Link } from 'gatsby';
import React from 'react';
import { getAwardColor } from '../../utils/ColorUtils.js';
import AwardIcon from '../svgs/AwardIcon';
import {
  awardCard,
  awardContainer,
  awardIcon,
  creativeTitle,
  project,
  textContainer,
} from './AwardCard.module.scss';

const AwardCard = ({ name, category, year, work, color }) => {
  color = getAwardColor(color);
  return (
    <li className={`fadeInEl ${awardContainer}`}>
      <div className={`${awardIcon} varColor${color}`}>
        <AwardIcon />
      </div>
      <div className={`${awardCard} shadowSmall`}>
        <div className={`${textContainer}`}>
          <h3 className={`h5 textCenter`}>
            {name}
            <span className={`block meta`}>
              {category}, {year}
            </span>
          </h3>
          {work && (
            <Link to={`/work/${work.slug}`} className={`${project}`}>
              <h4 className={`h6 strong`}>
                <span className={``}>
                  {work.title_creative && (
                    <span className={`${creativeTitle} `}>
                      {work.title_creative}{' '}
                    </span>
                  )}
                  {work.title_descriptive}
                </span>
                <span className={`block meta`}>{work.client.name}</span>
              </h4>
            </Link>
          )}
        </div>
      </div>
    </li>
  );
};

export default AwardCard;
